import { useTheme } from "@emotion/react";
import {
  AccessTimeOutlined,
  AddOutlined,
  Cached,
  CheckOutlined,
  Clear,
  ClearOutlined,
  ErrorOutlineOutlined,
  FilterAltOutlined,
  KeyboardDoubleArrowRightOutlined,
  SearchOutlined,
  TravelExploreOutlined,
} from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Button,
  Chip,
  CircularProgress,
  Divider,
  Drawer,
  Grid,
  IconButton,
  InputAdornment,
  Modal,
  Paper,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box, lighten } from "@mui/system";
import { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import ConfusedMaleNoBack from "../../../../components/artsPersonComponent/confusedMaleNoBack";
import InformationMaleNoBack from "../../../../components/artsPersonComponent/informationMaleNoBack";
import LoaderThreeDots from "../../../../components/loadingAnimation";
import StackedBarChart from "../../../../components/stackedBarChart";
import TicketModalContent from "../../../../components/tickets/detailsTicketComponent";
import FilterBar from "../../../../components/topBarFilter";
import FluxoAtendimento from "../fluxoAtendimento";

import SelectFilter from "../../../../components/selectFilter";
import useStyles from "./styles";
import ModalNewTicketIxc from "../../../../components/tickets/modalNewTicketIxc";
import FluxoAtendimentoIxc from "../fluxoAtendimentoIxc";
import ErpFilter from "../../../../components/erp/ErpFilter";
import useErpSelecionado from "../../../../components/erp/useErpSelecionado";
import { tiposDaTela, tiposDeBusca } from "../../../../services/telasErp";

export default function OsFluxo() {
  const [fluxoAtendimento, setFluxoAtendimento] = useState([]);
  const [countAtendimentos, setCountAtendimentos] = useState(0);
  const [selectEtapaFluxo, setSelectEtapaFluxo] = useState(null);
  const [selectEtapa, setSelectEtapa] = useState(null);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [buscarTicket, setBuscarTicket] = useState("");
  const [isSelecting, setIsSelecting] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [filterAtendimentos, setFilterAtendimentos] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [open, setOpen] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [newMensagem, setNewMensagem] = useState("");
  const [error, setError] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);
  const [searchValueProtocolo, setSearchValueProtocolo] = useState("");
  const [ticketDetails, setTicketDetails] = useState(null);
  const [value, setValue] = useState(0);
  const [openNewTicket, setOpenNewTicket] = useState(false);
  const [isExplicacao, setIsExplicacao] = useState(true);
  const [loadingTicketDetails, setLoadingTicketDetails] = useState(false);
  const [itensPublic, setItensPublic] = useState({
    mensagens: [],
    anexos: [],
    rfo: [],
  });
  const [statusTicketMensagem, setStatusTicketMensagem] = useState({});
  const [loadingCreateMensagem, setLoadingCreateMensagem] = useState(false);

  const [tecnicos, setTecnicos] = useState([]);
  const [tecnicosSelecionados, setTecnicosSelecionados] = useState([]);
  const [assuntos, setAssuntos] = useState([]);
  const [assuntosSelecionados, setAssuntosSelecionados] = useState([]);

  const [prioridades, setPrioridades] = useState([]);
  const [prioridadesSelecionados, setPrioridadesSelecionados] = useState([]);

  const [filiais, setFiliais] = useState([]);
  const [filiaisSelecionados, setFiliaisSelecionados] = useState([]);

  // ERP escolhido (só os tipos que têm a tela); todas as consultas levam o erpId.
  const { erps, erpId, setErpId, erp, carregado, variosErps } =
    useErpSelecionado(tiposDaTela("/interno/suporte/fluxoOs"));
  const labelErp =
    erp === "HUBSOFT"
      ? "Serviços"
      : erp === "VOALLE"
        ? "Contratos"
        : erp === "IXC"
          ? "Contrato"
          : "";

  const labelTabsErp = {
    descricao:
      erp === "HUBSOFT"
        ? "Descrição"
        : erp === "VOALLE"
          ? "Geral"
          : "Descrição",
    mensagens:
      erp === "HUBSOFT"
        ? "Mensagens"
        : erp === "VOALLE"
          ? "Histórico"
          : "Mensagens",
  };
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { controllerDashboard, setControllerDashboard, api } =
    useOutletContext();

  const colors = [
    theme.palette.cardTrafficData.paperColor.outputData,
    theme.palette.colors.blue.medium,
    theme.palette.colors.orange.dark,
    lighten(theme.palette.cardTrafficData.paperColor.speeData, 0.3),
    theme.palette.colors.blue.darker,
    lighten(theme.palette.colors.pink.dark, 0.3),
    theme.palette.colors.purple.medium,
    theme.palette.colors.yellow.dark,
  ];

  // Fluxo e opções dos filtros vêm do ERP: de novo a cada troca de ERP.
  useEffect(() => {
    if (!carregado) return;
    getFluxoAtendimento();
  }, [carregado, erpId]);

  // Troca de ERP: técnicos, assuntos, prioridades, filiais e OS selecionadas
  // são do ERP anterior.
  const handleChangeErp = (novoErpId) => {
    if (!novoErpId || novoErpId === erpId) return;
    setTecnicosSelecionados([]);
    setAssuntosSelecionados([]);
    setPrioridadesSelecionados([]);
    setFiliaisSelecionados([]);
    setSelectedItems([]);
    setIsSelecting(false);
    setSelectEtapa(null);
    setErpId(novoErpId);
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    handleSelectEtapa();
    setSelectedItems([]);
    setIsSelecting(false);
  }, [fluxoAtendimento, selectEtapa]);

  useEffect(() => {
    setFilterAtendimentos(filtrarAtendimentos(fluxoAtendimento, buscarTicket));
  }, [
    buscarTicket,
    fluxoAtendimento,
    tecnicosSelecionados,
    assuntosSelecionados,
    prioridadesSelecionados,
    filiaisSelecionados,
  ]);

  // alterna modo de seleção
  const handleToggleSelectMode = () => {
    setIsSelecting((prev) => !prev);
    setSelectedItems([]);
  };

  // marca/desmarca um atendimento
  const handleSelectItem = (atendimento) => {
    setSelectedItems((prev) => {
      const exists = prev.some(
        (item) => item.id_atendimento === atendimento.id_atendimento,
      );
      if (exists) {
        return prev.filter(
          (item) => item.id_atendimento !== atendimento.id_atendimento,
        );
      } else {
        return [...prev, atendimento];
      }
    });
  };
  const getFluxoAtendimento = async () => {
    setLoading(true);
    if (controllerDashboard) {
      controllerDashboard.abort();
    }
    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);

    try {
      const response = await api.post(
        "/interno/ticket/fluxoOs",
        { erpId: erpId || undefined },
        { signal },
      );
      setTecnicos(response?.data?.tecnicos);
      setAssuntos(response?.data?.assuntos);
      setPrioridades(response?.data?.prioridades);
      setFiliais(response?.data?.filiais);

      setFluxoAtendimento(adicionarCores(response.data?.fluxo));
      const totalAtendimentos = response?.data?.fluxo?.reduce(
        (acc, etapa) => acc + etapa?.atendimentos?.length,
        0,
      );
      setCountAtendimentos(totalAtendimentos);
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Erro ao buscar fluxo de OS",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const getOsDetailsForProtocolo = async () => {
    setLoadingTicketDetails(true);
    setIsExplicacao(false); //retirar imagem de explicação
    try {
      const response = await api.post(`/interno/osDetails/protocolo`, {
        protocolo: searchValueProtocolo?.trim(),
        erpId: erpId || undefined,
      });

      setTicketDetails(response?.data);
      setItensPublic((prev) => {
        const mensagens = [];
        const anexos = [];
        const anexosCliente = [];
        const rfo = [];
        for (const item of response?.data?.itensTicketPublic || []) {
          if (item?.itemType === "mensagem") {
            mensagens.push(item?.itemId);
          } else if (item?.itemType === "anexo") {
            anexos?.push(item?.itemId);
          } else if (item?.itemType === "anexoCliente") {
            anexosCliente?.push(item?.itemId);
          } else if (item?.itemType === "rfo") {
            rfo?.push(item?.itemId);
          }
        }

        return {
          ...prev,
          mensagens,
          anexos,
          anexosCliente,
          rfo,
        };
      });
    } catch (error) {
      setTicketDetails(null);
      console.log(error);
      setSnackbar({
        children: "Protocolo não encontrado",
        severity: "warning",
      });
    } finally {
      setLoadingTicketDetails(false);
    }
  };
  const getChipStatus = (status) => {
    switch (status) {
      case "fulfilled":
        return (
          <Tooltip title="Mensagem enviada com sucesso">
            <Chip
              size="small"
              sx={{
                ...styles.chipStatus,
                backgroundColor: theme.palette.colors.green.medium, // verde
              }}
              label={
                <Box sx={styles.containerStatusModal}>
                  <Typography sx={styles.titleChipModal}>Sucesso</Typography>
                  <CheckOutlined
                    sx={{
                      fontSize: "15px",
                      color: theme.palette.white.main,
                    }}
                  />
                </Box>
              }
            />
          </Tooltip>
        );

      case "rejected":
        return (
          <Tooltip title="Não foi possível enviar mensagem">
            <Chip
              size="small"
              sx={{
                ...styles.chipStatus,
                backgroundColor: theme.palette.colors.red.dark, // vermelho
              }}
              label={
                <Box sx={styles.containerStatusModal}>
                  <Typography sx={styles.titleChipModal}>Erro</Typography>
                  <ErrorOutlineOutlined
                    sx={{
                      fontSize: "15px",
                      color: theme.palette.white.main,
                    }}
                  />
                </Box>
              }
            />
          </Tooltip>
        );

      default:
        return (
          <Tooltip title="Preparando envio de mensagem">
            <Chip
              size="small"
              sx={{
                ...styles.chipStatus,
                backgroundColor: theme.palette.colors.blue.medium, // laranja
              }}
              label={
                <Box sx={styles.containerStatusModal}>
                  <Typography sx={styles.titleChipModal}>Preparando</Typography>
                  <AccessTimeOutlined
                    sx={{
                      fontSize: "15px",
                      color: theme.palette.white.main,
                    }}
                  />
                </Box>
              }
            />
          </Tooltip>
        );
    }
  };
  const handleOpenNewTicket = () => {
    setOpenNewTicket(true);
  };
  const handleCloseNewTicket = () => {
    setOpenNewTicket(false);
  };
  const createManyMensagem = async () => {
    setLoadingCreateMensagem(true);
    if (!newMensagem) {
      setError(true);
      return;
    }

    try {
      const arrayTicketId = selectedItems.map((item) => item.id_atendimento);
      const response = await api.post("/interno/createMany/mensagemTicket", {
        mensagem: newMensagem,
        arrayTicketId: arrayTicketId,
        erpId: erpId || undefined,
      });

      setStatusTicketMensagem(response?.data);
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Error: Não foi possível criar mensagens",
        severity: "error",
      });
    } finally {
      setLoadingCreateMensagem(false);
      setNewMensagem("");
      setError(false);
    }
  };

  const getTicketDetails = async (ticketId) => {
    try {
      const response = await api.post("/interno/find/os/id", {
        ticketId: ticketId,
        erpId: erpId || undefined,
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      setSnackbar({
        children: "Error: Não foi possível localizar detalhes do ticket",
        severity: "error",
      });
    } finally {
    }
  };


  const filtrarAtendimentos = (data, termo) => {
    // Se não houver termo e nenhum técnico selecionado, retorna o array original
    const semFiltro =
      (!termo || termo.trim() === "") &&
      (!tecnicosSelecionados || tecnicosSelecionados?.length === 0) &&
      (!assuntosSelecionados || assuntosSelecionados?.length === 0) &&
      (!prioridadesSelecionados || prioridadesSelecionados?.length === 0) &&
      (!filiaisSelecionados || filiaisSelecionados?.length === 0);

    if (semFiltro) {
      const etapaFluxoAtendimento = data?.find(
        (item) =>
          item?.etapaFluxoAtendimento === selectEtapa?.name ||
          item?.etapaFluxoAtendimento === selectEtapa?.etapaFluxoAtendimento,
      );
      setSelectEtapa(etapaFluxoAtendimento || null);

      return data;
    }

    const termoLower = termo?.toLowerCase?.()?.trim() || "";

    const filter = data
      ?.map((etapa) => {
        const atendimentosFiltrados = etapa?.atendimentos?.filter((a) => {
          const nome = a?.cliente?.nome?.toLowerCase() || "";
          const protocolo = a?.protocolo?.toLowerCase() || "";
          const descricao = a?.descricao_abertura?.toLowerCase() || "";
          const status = a?.status?.toLowerCase() || "";
          const idServico =
            a?.idClienteServico?.toString()?.toLowerCase() || "";
          const userAbertura = a?.usuario_abertura?.toLowerCase() || "";
          const assunto = a?.assunto?.toLowerCase() || "";
          const prioridade = a?.prioridade?.toLowerCase() || "";
          const filial = a?.filial?.toLowerCase() || "";
          const setor = a?.setor?.toLowerCase() || "";
          const idTicket = a?.id_ticket?.toString()?.toLowerCase() || "";
          // Filtro principal por termo
          const correspondeAoTermo =
            termoLower === "" ||
            nome.includes(termoLower) ||
            protocolo.includes(termoLower) ||
            descricao.includes(termoLower) ||
            status.includes(termoLower) ||
            idServico.includes(termoLower) ||
            userAbertura.includes(termoLower) ||
            assunto.includes(termoLower) ||
            prioridade.includes(termoLower) ||
            filial.includes(termoLower) ||
            setor.includes(termoLower) ||
            idTicket?.includes(termoLower);

          // Filtro adicional pelos técnicos selecionados
          const filterTecnicos =
            !tecnicosSelecionados ||
            tecnicosSelecionados.length === 0 ||
            tecnicosSelecionados.some((t) => t.toLowerCase() === userAbertura);

          const filterAssuntos =
            !assuntosSelecionados ||
            assuntosSelecionados.length === 0 ||
            assuntosSelecionados.some((t) => t.toLowerCase() === assunto);

          const filterPrioridades =
            !prioridadesSelecionados ||
            prioridadesSelecionados.length === 0 ||
            prioridadesSelecionados.some((t) => t.toLowerCase() === prioridade);
          // Só mantém se atender ambos

          const filterFiliais =
            !filiaisSelecionados ||
            filiaisSelecionados.length === 0 ||
            filiaisSelecionados.some((t) => t.toLowerCase() === filial);
          return (
            correspondeAoTermo &&
            filterTecnicos &&
            filterAssuntos &&
            filterPrioridades &&
            filterFiliais
          );
        });

        return {
          ...etapa,
          atendimentos: atendimentosFiltrados,
          atendimentosCount: atendimentosFiltrados.length,
        };
      })
      ?.filter((etapa) => etapa.atendimentos.length > 0);

    setSelectEtapa(filter?.[0] || null);

    return filter;
  };

  function formatEtapasForChart(etapas) {
    if (!etapas || etapas?.length === 0) return [];

    return etapas?.map((etapa) => ({
      etapaFluxoAtendimento: etapa?.etapaFluxoAtendimento,
      atendimentosCount: etapa?.atendimentos?.length || 0,
      posicao: etapa?.posicao,
    }));
  }
  function adicionarCores(objetos) {
    return objetos.map((obj, index) => ({
      ...obj,
      color: colors[index % colors?.length],
    }));
  }
  const statusChamado = {
    "Aguardando Análise": 1,
    Resolvido: 2,
    Pendente: 3,
    Cancelado: 4,
    Aberto: 5,
    Encaminhado: 6,
    Agendado: 7,
    "Em Análise": 8,
    Assumido: 9,
    "Em execução": 10,
    Finalizado: 11,
    Deslocamento: 12,
  };
  const handleSelectEtapa = () => {
    const etapaFluxoAtendimento = filterAtendimentos?.find(
      (item) =>
        item?.etapaFluxoAtendimento === selectEtapa?.name ||
        item?.etapaFluxoAtendimento === selectEtapa?.etapaFluxoAtendimento,
    );

    setSelectEtapaFluxo(etapaFluxoAtendimento);
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedItems(selectEtapaFluxo?.atendimentos); // seleciona todos
    } else {
      setSelectedItems([]); // limpa todos
    }
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setStatusTicketMensagem({});
    setNewMensagem("");
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleOpenSearch = () => setOpenSearch(true);
  const handleCloseSearch = () => {
    setIsExplicacao(true);
    setOpenSearch(false);
    setTicketDetails(null);
    setSearchValueProtocolo("");
    setValue(0);
  };

  const toggleDrawer = (newOpen) => {
    setOpenDrawer(newOpen);
  };
  const partiallySelected =
    selectedItems.length > 0 &&
    selectedItems.length < selectEtapaFluxo?.atendimentos?.length;

  const allSelected =
    selectEtapaFluxo?.atendimentos?.length > 0 &&
    selectedItems.length === selectEtapaFluxo?.atendimentos.length;

  const actions = [
    {
      icon: <FilterAltOutlined />,
      name: "Filtro",
      onClick: () => setOpenFilter(true),
    },
    {
      icon: <TravelExploreOutlined />,
      name: "Atualizar",
      onClick: () => handleOpenSearch(),
    },

    {
      icon: <Cached />,
      name: "Atualizar",
      onClick: () => getFluxoAtendimento(),
    },
    ...(erp === "IXC"
      ? [
          {
            icon: <AddOutlined />,
            name: "Nova OS",
            onClick: () => handleOpenNewTicket(),
          },
        ]
      : []),
  ];

  const handleChangeTecnicos = (novosValores) => {
    setTecnicosSelecionados(novosValores);
  };
  const handleCloseTecnicos = () => {};

  const handleChangeAssuntos = (novosValores) => {
    setAssuntosSelecionados(novosValores);
  };
  const handleCloseAssuntos = () => {};

  const handleChangePrioridades = (novosValores) => {
    setPrioridadesSelecionados(novosValores);
  };
  const handleClosePrioridades = () => {};

  const handleChangeFiliais = (novosValores) => {
    setFiliaisSelecionados(novosValores);
  };
  const handleCloseFiliais = () => {};
  return (
    <>
      <FilterBar
        actions={actions}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        type={1}
        widthParamsMobile={1644}
        selectorComponentLeft={
          <Box
            sx={{
              display: "flex",
              "@media (max-width: 1643px)": { flexDirection: "column" },
              gap: 1,
              width: "100%",
            }}
          >
            {variosErps && (
              <ErpFilter
                erps={erps}
                value={erpId}
                onChange={handleChangeErp}
                limpavel={false}
                id="filtro-erp-fluxo-os"
                sx={{ minWidth: 200 }}
              />
            )}
            <Box sx={{ width: "100%", maxWidth: 500 }}>
              <TextField
                id="input-with-icon-textfield"
                size="small"
                label="Buscar OS"
                variant="outlined"
                autoComplete="off"
                placeholder="Protocolo, descrição, etc..."
                sx={styles.search}
                value={buscarTicket}
                onChange={(event) => {
                  setBuscarTicket(event?.target?.value?.trimStart());
                }}
                InputProps={{
                  endAdornment: buscarTicket ? (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => setBuscarTicket("")}
                        edge="end"
                      >
                        <Clear size={"small"} />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
                }}
              />
            </Box>
            {assuntos?.length > 0 && (
              <Box sx={{ width: "100%", maxWidth: 500 }}>
                <SelectFilter
                  label="Assunto"
                  options={assuntos}
                  value={assuntosSelecionados}
                  onChange={handleChangeAssuntos}
                  onClose={handleCloseAssuntos}
                />
              </Box>
            )}
            {filiais?.length > 0 && (
              <Box sx={{ width: "100%", maxWidth: 500 }}>
                <SelectFilter
                  label="Filial"
                  options={filiais}
                  value={filiaisSelecionados}
                  onChange={handleChangeFiliais}
                  onClose={handleCloseFiliais}
                />
              </Box>
            )}
            {prioridades?.length > 0 && (
              <Box sx={{ width: "100%", maxWidth: 500 }}>
                <SelectFilter
                  label="Prioridade"
                  options={prioridades}
                  value={prioridadesSelecionados}
                  onChange={handleChangePrioridades}
                  onClose={handleClosePrioridades}
                />
              </Box>
            )}
            {tecnicos?.length > 0 && (
              <Box sx={{ width: "100%", maxWidth: 500 }}>
                <SelectFilter
                  label="Técnico"
                  options={tecnicos}
                  value={tecnicosSelecionados}
                  onChange={handleChangeTecnicos}
                  onClose={handleCloseTecnicos}
                />
              </Box>
            )}
          </Box>
        }
        selectorComponentRight={
          <>
            {windowWidth >= 1643 && (
              <Box sx={{ display: "flex", gap: 1.5 }}>
                <Tooltip title="Busca global">
                  <Button
                    size="small"
                    variant="outlined"
                    disabled={loading}
                    onClick={() => handleOpenSearch()}
                    sx={styles.buttonSearch}
                  >
                    <TravelExploreOutlined
                      fontSize="small"
                      sx={{ color: theme.palette.text.main }}
                      className={loading ? "rotating" : ""}
                    />
                  </Button>
                </Tooltip>
                <Tooltip title="Atualizar">
                  <Button
                    size="small"
                    variant="outlined"
                    disabled={loading}
                    onClick={() => getFluxoAtendimento()}
                    sx={styles.buttonRefresh}
                  >
                    <Cached
                      fontSize="small"
                      sx={{ color: theme.palette.text.main }}
                      className={loading ? "rotating" : ""}
                    />
                  </Button>
                </Tooltip>
                {erp === "IXC" && (
                  <Tooltip title="Novo OS">
                    <Button
                      startIcon={<AddOutlined fontSize="small" />}
                      variant="contained"
                      disabled={loading}
                      sx={{ width: 133, height: 43 }}
                      onClick={() => handleOpenNewTicket()}
                    >
                      Novo OS
                    </Button>
                  </Tooltip>
                )}
              </Box>
            )}
          </>
        }
      />
      {loading ? (
        <Box sx={{ mt: 20 }}>
          <LoaderThreeDots />
        </Box>
      ) : (
        <>
          <Box sx={styles.boxHeader}>
            <Box sx={styles.containerStackedBarChart}>
              <StackedBarChart
                colors={colors}
                isPropertyColor={true}
                setSelectEtapa={setSelectEtapa}
                data={formatEtapasForChart(filterAtendimentos)}
                selectEtapaFluxo={selectEtapaFluxo}
                property="etapaFluxoAtendimento"
                toggleDrawer={toggleDrawer}
                windowWidth={windowWidth}
                titulo={
                  fluxoAtendimento?.[0]?.descricaoFluxoAtendimento &&
                  `${fluxoAtendimento?.[0]?.descricaoFluxoAtendimento} - (${countAtendimentos})`
                }
              />
            </Box>
          </Box>
          <Box sx={styles.boxBody}>
            <Grid
              container
              spacing={1}
              columns={{
                xs: 8,
                sm: 8,
                smx: 12,
                md: 12,
                lg: 12,
                xl: 12,
                xxl: 12,
              }}
            >
              <Grid
                sx={styles.paperFluxo}
                item
                xs={8}
                sm={8}
                smx={4}
                md={4}
                lg={4}
              >
                <Paper
                  elevation={theme.palette.mode === "dark" ? 0 : 3}
                  sx={{ ...styles.paperFluxo }}
                >
                  <FluxoAtendimento
                    fluxoAtendimento={filterAtendimentos}
                    loading={loading}
                    setSelectEtapa={setSelectEtapa}
                    selectEtapaFluxo={selectEtapaFluxo}
                    toggleDrawer={toggleDrawer}
                    windowWidth={windowWidth}
                    isPropertyColor={true}
                  />
                </Paper>
              </Grid>{" "}
              {windowWidth >= 750 && (
                <Grid
                  sx={styles.paperFluxo}
                  item
                  xs={8}
                  sm={8}
                  smx={8}
                  md={8}
                  lg={8}
                >
                  <FluxoAtendimentoIxc
                    theme={theme}
                    styles={styles}
                    selectEtapaFluxo={selectEtapaFluxo}
                    isSelecting={isSelecting}
                    allSelected={allSelected}
                    partiallySelected={partiallySelected}
                    selectedItems={selectedItems}
                    handleSelectAll={handleSelectAll}
                    handleToggleSelectMode={handleToggleSelectMode}
                    handleOpen={handleOpen}
                    handleSelectItem={handleSelectItem}
                    getTicketDetails={getTicketDetails}
                    setSnackbar={setSnackbar}
                    labelErp={labelErp}
                    statusChamado={statusChamado}
                    typeTitleModal={"Ordem de serviço"}
                    refreshAtendimentos={getFluxoAtendimento}
                    isOs={true}
                    erp={erp}
                    erpId={erpId || undefined}
                  />
                </Grid>
              )}
            </Grid>
          </Box>
        </>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styles.modal}>
          <Box sx={styles.containerModal}>
            <Box>
              <Typography sx={styles.titleModal}>
                Enviar mensagem para:
              </Typography>
              <Paper variant="outlined" sx={styles.paperAllTickets}>
                {selectedItems.map((item) => (
                  <Paper variant="outlined" sx={styles.paperTickets}>
                    <Box sx={{ overflow: "hidden" }}>
                      <Box sx={styles.boxData}>
                        <Typography sx={styles.titleDataModal}>
                          Protocolo:
                        </Typography>
                        <Typography sx={styles.titleDataProtocoloModal}>
                          {item?.protocolo}
                        </Typography>
                      </Box>

                      <Box sx={styles.boxData}>
                        <Typography sx={styles.titleDataModal}>
                          Cliente:
                        </Typography>
                        <Typography sx={styles.titleDataClienteModal}>
                          {item?.cliente?.nome}
                        </Typography>
                      </Box>
                    </Box>
                    {loadingCreateMensagem ? (
                      <Box sx={styles.containerStatusMensagem}>
                        <Typography sx={styles.titleDataModal}>
                          Status de envio:
                        </Typography>
                        <CircularProgress size={20} />
                      </Box>
                    ) : (
                      <Box sx={styles.containerStatusMensagem}>
                        <Typography sx={styles.titleDataModal}>
                          Status de envio:
                        </Typography>
                        {getChipStatus(
                          statusTicketMensagem[
                            item?.id_atendimento?.toString()
                          ],
                        )}
                      </Box>
                    )}
                  </Paper>
                ))}
              </Paper>
            </Box>
            <Box sx={styles.containerSendMensagem}>
              <TextField
                sx={{ width: "100%" }}
                error={error && !newMensagem?.trim()}
                helperText={
                  !newMensagem?.trim() && error && "Campo obrigatorio"
                }
                disabled={loadingCreateMensagem}
                placeholder="Mensagem"
                label="Mensagem"
                multiline
                rows={4}
                value={newMensagem}
                onChange={(e) => setNewMensagem(e.target.value)}
              />
              <Box sx={styles.containerActionsMensagens}>
                <Button disabled={loadingCreateMensagem} onClick={handleClose}>
                  Cancelar
                </Button>
                <LoadingButton
                  onClick={createManyMensagem}
                  loading={loadingCreateMensagem}
                  disabled={loadingCreateMensagem || !newMensagem?.trim()}
                  variant="contained"
                >
                  Enviar
                </LoadingButton>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>

      {ticketDetails ? (
        <>
          {" "}
          <TicketModalContent
            open={openSearch}
            handleClose={handleCloseSearch}
            erp={erp}
            erpId={erpId || undefined}
            ticketDetails={ticketDetails}
            status={ticketDetails?.status}
            labelTabsErp={labelTabsErp}
            value={value}
            handleChange={handleChange}
            isEdit={true}
            setTicketDetails={setTicketDetails}
            itensPublic={itensPublic}
            setItensPublic={setItensPublic}
            setSnackbar={setSnackbar}
          />
        </>
      ) : (
        <Modal
          open={openSearch}
          onClose={handleCloseSearch}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styles.modalSearch}>
            <Box sx={styles.containerBoxClearSearch}>
              <IconButton>
                <ClearOutlined onClick={handleCloseSearch} />
              </IconButton>
            </Box>
            <Box
              component="form"
              onSubmit={(e) => {
                e.preventDefault();
                // Busca de OS no ERP escolhido, se ele tiver (services/telasErp).
                if (
                  searchValueProtocolo?.trim() &&
                  !loadingTicketDetails &&
                  tiposDeBusca("/interno/suporte/fluxoOs", erp).includes("os")
                ) {
                  getOsDetailsForProtocolo();
                }
              }}
              sx={styles.containerSearch}
            >
              <TextField
                sx={{ width: "100%" }}
                size="small"
                placeholder="Digite o protocolo do ticket"
                label="Protocolo"
                value={searchValueProtocolo}
                onChange={(e) => setSearchValueProtocolo(e.target.value)}
              />
              <Button
                size="small"
                variant="contained"
                type="submit" // importante para funcionar com Enter
                disabled={loadingTicketDetails || !searchValueProtocolo?.trim()}
                sx={styles.buttonSearchModal}
              >
                <SearchOutlined fontSize="small" />
              </Button>
            </Box>

            <Box sx={styles.boxNoTickets}>
              {loadingTicketDetails ? (
                <CircularProgress size={30} color="secondary" />
              ) : (
                <>
                  {isExplicacao && (
                    <InformationMaleNoBack
                      backgroundGradinetDark={
                        theme.palette.buttonHoverGradient.dark
                      }
                      backgroundGradinetLight={
                        theme.palette.buttonHoverGradient.light
                      }
                      title={"Pesquise qualquer ticket por"}
                      highlight={"protocolo."}
                    />
                  )}
                  {!isExplicacao && !ticketDetails && (
                    <ConfusedMaleNoBack
                      primaryCircleFill={theme.palette.primary.main}
                      highlightTitle={"Oops!"}
                      subtitle={
                        "Parece que não encontramos\nnenhum ticket referente\na esse"
                      }
                      highlightSubtitle={"protocolo."}
                    />
                  )}
                </>
              )}
            </Box>
          </Box>
        </Modal>
      )}

      {erp === "IXC" && (
        <ModalNewTicketIxc
          open={openNewTicket}
          handleClose={handleCloseNewTicket}
          refrashTIckets={getFluxoAtendimento}
          isOs={true}
          erp={erp}
          erpId={erpId || undefined}
        />
      )}

      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => toggleDrawer(false)}
      >
        <Box sx={styles.containerCloseDrawer}>
          <Box sx={{ p: 1 }}>
            <IconButton onClick={() => toggleDrawer(false)}>
              <KeyboardDoubleArrowRightOutlined />
            </IconButton>
          </Box>

          <Divider />
        </Box>
        <Box sx={{ ...styles.paperFluxo, width: "80vw" }}>
          <FluxoAtendimentoIxc
            theme={theme}
            styles={styles}
            selectEtapaFluxo={selectEtapaFluxo}
            isSelecting={isSelecting}
            allSelected={allSelected}
            partiallySelected={partiallySelected}
            selectedItems={selectedItems}
            handleSelectAll={handleSelectAll}
            handleToggleSelectMode={handleToggleSelectMode}
            handleOpen={handleOpen}
            handleSelectItem={handleSelectItem}
            getTicketDetails={getTicketDetails}
            setSnackbar={setSnackbar}
            labelErp={labelErp}
            statusChamado={statusChamado}
            typeTitleModal={"Ordem de serviço"}
            erp={erp}
            erpId={erpId || undefined}
          />
        </Box>
      </Drawer>

      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </>
  );
}
